import { ShieldAlert } from 'lucide-react';
import { useTranslation } from '../../context/TranslationContext';

export const NoAccess = () => {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col items-center justify-center text-center py-24" data-testid="admin-no-access">
      <div className="w-16 h-16 rounded-full bg-muted flex items-center justify-center mb-4">
        <ShieldAlert className="w-8 h-8 text-muted-foreground" />
      </div>
      <h1 className="text-2xl font-serif font-medium mb-2">
        {t('admin_no_access_title', 'No access')}
      </h1>
      <p className="text-muted-foreground max-w-sm">
        {t('admin_no_access_desc', "You don't have permission to view this page. Ask a super admin to grant you access.")}
      </p>
    </div>
  );
};
